export default __webpack_public_path__ + "static/media/planilla.fb17a94f.svg";